import React from 'react';
import axios from "axios";
import publicIp from "public-ip";

import Header from "./components/Header";
import Down from "./components/Down";
import Progress from "./components/Progress";
import Error from "./components/Error";
import YourDetails from "./components/YourDetails";
import Ratings from "./components/Ratings";
import Controls from "./components/Controls";
import Success from "./components/Success";
import Footer from "./components/Footer";

class Vote extends React.Component {

    state = {
        connection: 1,
        step: 0,
        error: null,
        name: "",
        email: "",
        company: "",
        position: "",
        recommendation: "",
        teamMember: "",
        teamLeader: "",
        remuneration: null,
        benefits: null,
        careerProgression: null,
        workingEnvironment: null,
        workLifeBalance: null,
        training: null,
        familyFriendly: null,
        mentalHealth: null,
        socialEnvironment: null
    };

    componentDidMount() {
        if(!localStorage.getItem("watermark")){
            let watermark = [];
            let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            for(let i = 0; i < 64; i++ ){
                watermark.push(characters.charAt(Math.floor(Math.random() * characters.length)));
            }
            watermark = watermark.join("");
            localStorage.setItem("watermark", watermark);
        }

        axios.get("https://best-place-to-work-api.bbg.im/version").then((result) => {
            console.log(`Version: ${result.data[0].version}`);
            this.setState({
                connection: 2
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                connection: 0
            })
        })
    }

    handleUpdate = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    };

    handleSubmit = async () => {
        let ip = await publicIp.v4();
        axios.post("https://best-place-to-work-api.bbg.im/vote", {
            "ip": ip,
            "email": this.state.email,
            "watermark": localStorage.getItem("watermark"),
            "name": this.state.name,
            "company": this.state.company,
            "position": this.state.position,
            "recommendation": this.state.recommendation,
            "teamMember": this.state.teamMember,
            "teamLeader": this.state.teamLeader,
            "remuneration": this.state.remuneration,
            "benefits": this.state.benefits,
            "careerProgression": this.state.careerProgression,
            "workingEnvironment": this.state.workingEnvironment,
            "workLifeBalance": this.state.workLifeBalance,
            "training": this.state.training,
            "familyFriendly": this.state.familyFriendly,
            "mentalHealth": this.state.mentalHealth,
            "socialEnvironment": this.state.socialEnvironment
        }).then(() => {
            this.setState({
                error: null,
                step: 2
            }, () => {
                window.scrollTo(0, 0)
            })
        }).catch(() => {
            this.setState({
                error: "There was an error submitting your ratings, please wait a moment and try again."
            })
        })
    };

    back = () => {
        let step = this.state.step;
        step = step > 0 ? step - 1 : 0;
        this.setState({ step }, () => {
            window.scrollTo(0, 0)
        });
    };

    next = () => {
        let step = this.state.step;
        step = step < 2 ? step + 1 : 2;
        this.setState({ step }, () => {
            window.scrollTo(0, 0);
        });
    };

    render() {

        let valid = true;
        if(this.state.step === 0){
            if(!/^\s*\S+.*/.test(this.state.name)) valid = false;
            if(!/^\s*\S+.*/.test(this.state.email)) valid = false;
            if(!/^\s*\S+.*/.test(this.state.company)) valid = false;
            if(!/^\s*\S+.*/.test(this.state.position)) valid = false;
        }
        if(this.state.step === 1){
            if(this.state.remuneration === null) valid = false;
            if(this.state.benefits === null) valid = false;
            if(this.state.careerProgression === null) valid = false;
            if(this.state.workingEnvironment === null) valid = false;
            if(this.state.workLifeBalance === null) valid = false;
            if(this.state.training === null) valid = false;
            if(this.state.familyFriendly === null) valid = false;
            if(this.state.mentalHealth === null) valid = false;
            if(this.state.socialEnvironment === null) valid = false;
            if(this.state.recommendation === null || this.state.recommendation === "") valid = false
        }

        return (
            <>
                <Header />
                <main>
                    <div>
                        {this.state.connection === 0 ?
                            <Down />
                        : this.state.connection === 1 ?
                            false
                        : this.state.connection === 2 ?
                            <div className="container">
                                {this.state.step < 3 && <Progress step={this.state.step} />}
                                {this.state.step === 0 ?
                                    <YourDetails {...this.state} handleUpdate={this.handleUpdate} />
                                : this.state.step === 1 ?
                                    <Ratings {...this.state} handleUpdate={this.handleUpdate} />
                                : this.state.step === 2 ?
                                    <Success {...this.state} />
                                : false }
                                {this.state.error && <Error error={this.state.error} />}
                                {this.state.step < 2 && <Controls {...this.state} back={this.back} next={this.next} valid={valid} handleSubmit={this.handleSubmit} />}
                            </div>
                        : false}
                    </div>
                </main>
                <Footer />
            </>
        )
    }
}

export default Vote;